import { COLLECTIONS_WITH_DIRECTORY_TAB } from 'src/config/config'

/**
 * Determines the appropriate tab for a collection.
 * - For slugs in COLLECTIONS_WITH_DIRECTORY_TAB (e.g. startup-central): always 'directory'.
 * - For all others: 'content' if content exists, otherwise 'directory'.
 */
export const getCollectionTab = (collectionData: any): string => {
  const slug = collectionData?.slug
  if (slug && COLLECTIONS_WITH_DIRECTORY_TAB.includes(slug)) {
    return 'directory'
  }
  if (collectionData?.contents?.length > 0) {
    return 'content'
  }
  return 'directory'
}
